import { I18n } from "@lingui/core";
import { t } from "@lingui/macro";
import { useBreakpoints } from "@otrium/core";
import { AuthProvider } from "src/pages/api/auth/getUserTokenFromApi";
import { useEffect, useMemo, useState } from "react";
import { Skeleton } from "src/atoms/Skeleton";
import { SocialButton } from "src/atoms/SocialButton";
import { signIn } from "src/utils/nextAuth";
import { SignLocation } from "src/tracking/segment";
import styles from "../LoginOrRegisterView.module.scss";

type SocialLoginProps = {
  isCheckoutPath?: boolean;
  i18n: I18n;
};

function SocialButtons({
  isCheckoutPath,
  i18n,
}: SocialLoginProps): JSX.Element {
  const { isDesktop } = useBreakpoints();
  const [isClient, setIsClient] = useState(false);

  const socialButtons: {
    type: "google" | "facebook";
    dataTestId: string;
    onClick: () => void;
    label: string;
  }[] = useMemo(
    () => [
      {
        type: "google",
        dataTestId: "login-page-google-button",
        onClick() {
          void signIn(AuthProvider.GOOGLE, {
            ...(isCheckoutPath ? { location: SignLocation.CHECKOUT } : {}),
          });
        },
        label: !isDesktop ? `${t(i18n)`Continue with`} Google` : "Google",
      },
      {
        type: "facebook",
        dataTestId: "login-page-fb-button",
        onClick() {
          void signIn(AuthProvider.FACEBOOK, {
            ...(isCheckoutPath ? { location: SignLocation.CHECKOUT } : {}),
          });
        },
        label: !isDesktop ? `${t(i18n)`Continue with`} Facebook` : "Facebook",
      },
    ],
    [isCheckoutPath, i18n, isDesktop]
  );

  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsClient(true);
    }
  }, []);

  return (
    <section className={styles.socialButtons}>
      {socialButtons.map(({ type, dataTestId, onClick, label }) => (
        <SocialButton
          key={type}
          data-testid={dataTestId}
          type={type}
          fullWidth
          noWrapper
          onClick={onClick}
        >
          {!isClient ? <Skeleton width="50px" invert /> : label}
        </SocialButton>
      ))}
    </section>
  );
}

export { SocialButtons };
